import React, { Component } from 'react';
import HttpClient from "../../libs/http";
import OrdersTotalizers from './OrdersTotalizers';
import OrdersRanking from './OrdersRanking';
import OrdersCooktop from './OrdersCooktop';
import Loader from 'react-loader-advanced';
import TopCountries from './TopCountries';

const http = new HttpClient();
const queryString = require("query-string");
let worker = null;

export default class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      hiddenAccount: true,
      ranking: {},
      totals: {},
      countries: {},
      columns: { c1: [], c2: [] },
      number: null,
      animation: null,
      last_updated: new Date().toString("HH:mm:ss")
    };
  }
  async componentWillMount() {
    await this.getData();
    worker = setInterval(this.getData, 30000);
  }
  componentWillUnmount() {
    if (worker) clearInterval(worker);
  }

  getPathname = () => {
    let pathname = window.location.pathname;
    let name = null;
    switch (pathname) {
      case '/cooktop':
      case '/orders/cooktop':
        name = 'Cooktop';
        pathname = '/api/pvt/orders/ranking/totals';
        break;
      case '/percountry':
      case '/orders/percountry':
        name = 'Country';
        pathname = '/api/pvt/orders/ranking/percountry';
        break;
      case '/persegment':
      case '/orders/persegment':
        name = 'Segment';
        pathname = '/api/pvt/orders/ranking/persegment';
        break;
      case '/persquad':
      case '/orders/persquad':
        name = 'Squad';
        pathname = '/api/pvt/orders/ranking/persquad';
        break;
      default:
        name = 'Account';
        pathname = '/api/pvt/orders/ranking/peraccount';
        break;
    }
    return { pathname, name };
  };

  getData = async () => {
    let query = queryString.parse(window.location.search);
    const now = new Date();
    let currentDate = now;

    const utc = now.getTime()
    const offset = query.offset || 0

    if (offset) {
      const oneHourMs = 1 * 3600 * 1000
      currentDate = new Date(utc + oneHourMs * offset)
    }

    const { pathname, name } = this.getPathname();
    currentDate.setSeconds(0);
    currentDate.setMilliseconds(0);
    const data = await http.GET(
      pathname +
      "?PS=" +
      (query.PS || 52) +
      "&page=" +
      (query.page || 1) +
      "&from=" +
      (query.from
        ? Date.toDate(query.from).toString()
        : Date.today().toString()) +
      "&to=" +
      (query.to ? Date.toDate(query.to).toString() : currentDate.toString()) +
      "&country=" +
      (query.country || "*") +
      "&squad=" +
      (query.squad || "*") +
      "&segment=" +
      (query.segment || "*") +
      "&origin=" +
      (query.origin || "*") +
      '&lastYearShift=' +
      (query.lastYearShift || 'foward') +
      "&showAccounts=" +
      (query.showAccounts || "false")
      + (query.statuses ? `&statuses=${query.statuses}` : '')
      + (query.account ? `&account=${query.account}` : '') +
      '&noChild=' +
      (query.noChild || 'false')
    );

    const newState = this.state;
    newState.show_last_year = data.totals.lastYear.count !== null;
    newState.last_updated = currentDate.toString("HH:mm:ss");
    newState.name = name;
    newState.totals = data.totals;
    newState.countries = data.countries;
    if (name !== 'Cooktop') newState.columns = this.splitGroup(data.ranking);

    if (Date.today().toString('yyyy-MM-dd') === '2022-11-25') {
      let number = (Math.floor(data.totals.now.count / 100000)) * 100000;
      if (newState.number === null) {
        newState.animation = null;
        newState.number = number;
      }
      else if (newState.number < number) {
        newState.number = number;
        newState.animation = number % 500000 === 0 ? 'fireworks' : this.weighted_random([{ item: 'schirmer', weight: 5 },{ item: 'bcap', weight: 2 },{ item: 'rod', weight: 1 } ])
        setTimeout(_ => this.setState({ animation: null }), 30000);
      }
    }
    newState.loaded = true;
    this.setState(newState);
  };

  weighted_random = (options) => {
    var i;

    var weights = [];

    for (i = 0; i < options.length; i++)
        weights[i] = options[i].weight + (weights[i - 1] || 0);
    
    var random = Math.random() * weights[weights.length - 1];
    
    for (i = 0; i < weights.length; i++)
        if (weights[i] > random)
            break;
    
    return options[i].item;
}

  splitGroup = items => {
    var lenght = items.length;
    for (var i = 0; i < lenght; i++) {
      items[i].position = i + 1;
    }
    var l = Math.ceil(lenght / 2);
    return { c1: items.slice(0, l), c2: items.slice(l, lenght) };
  };


  render() {
    let query = queryString.parse(window.location.search);
    return (
      <div className="ph2 white">
        <Loader show={ !this.state.loaded } message={ 'Loading...' } backgroundStyle={ { backgroundColor: 'black' } }>
          <OrdersTotalizers
            loaded={ this.state.loaded }
            data={ this.state.totals }
            number={ this.state.number }
            animation={ this.state.animation }
            last_updated={ this.state.last_updated }
            show_last_year= { this.state.show_last_year }
          />
          <div className={ query.showCountry === "false" ? 'dn' : '' }>
            <TopCountries
              loaded={ this.state.loaded }
              data={ this.state.countries }
            />
          </div>
          {
            this.state.name !== 'Cooktop'
              ? (<OrdersRanking
                name={ this.state.name }
                loaded={ this.state.loaded }
                columns={ this.state.columns }
                show_last_year= { this.state.show_last_year }
              />)
              : false
          }
        </Loader>
        {
          this.state.name === 'Cooktop'
          ? <OrdersCooktop />
          : false
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Orders/index.js